<template>
    <app-page-options-list :options="options" />
</template>
<script>
import PageOptionsList from '../UI/Controls/PageOptions/PageOptionsList.vue';

export default {
    components: {
        appPageOptionsList: PageOptionsList
    },
    data() {
        return {
            options: [
                { to: 'itemsQuotationPage', label: 'Items' },
                { to: 'quotationSettingsPage', label: 'Configuración de Cotizaciones' },
                { to: 'quotationsPage', label: 'Cotizaciones' }
            ]
        };
    }
};
</script>

